import { getScalarValue } from "src/business/attribute/getScalarValue";
import { cmpScalarValues } from "src/common/cmpScalarValues";
import {
  ZExprBool,
  ZExprBoolField,
  ZExprBoolList,
  ZExprFieldValue,
} from "src/types/ZExprBool";

import { calcExprValue } from "../formNav/calcExprValue";
import { MfNode } from "./MfNode";

export type ExprBoolCtx = {
  root: MfNode;
  onVisibilityChange(): void;
};

export type ExprBool = (node: MfNode, ctx: ExprBoolCtx) => boolean;

/* eslint consistent-return: "off" */
/* eslint default-case: "off" */

export const createExprBool = (
  meta: ZExprBool | null | undefined,
): ExprBool | undefined => {
  if (!meta) return undefined;
  switch (meta.type) {
    case "true":
      return () => true;
    case "boolField":
      return boolField(meta);
    case "fieldValue":
      return fieldValue(meta);
    case "or":
      return createExprBoolOr(meta.ops);
  }
};

const createExprBoolOr = (ops: ZExprBoolList): ExprBool => {
  const exprList = ops.map((op) => createExprBool(op)).filter((expr) => !!expr);
  return (node, ctx) => {
    const found = exprList.map((expr) => expr(node, ctx));
    return !!found;
  };
};

const boolField =
  (meta: ZExprBoolField): ExprBool =>
  (node, ctx) => {
    const value = calcExprValue(meta.path, node, ctx.root);
    return meta.inv ? !value : !!value;
  };

const fieldValue =
  (meta: ZExprFieldValue): ExprBool =>
  (node, ctx) => {
    const value = getScalarValue(calcExprValue(meta.path, node, ctx.root));
    return !!cmpScalarValues(meta.op, value, meta.value);
  };
